import { Observable } from 'rxjs';
import { Message } from "./message";
import { User } from "./user";
import { ChatP } from '../../chat/chat.model';

export abstract class ChatAdapter
{
    // ### Abstract adapter methods ###

    public abstract listFriends(): Observable<ChatP[]>;
    
    public abstract getMessageHistory(userId: any): Observable<ChatP[]>;

    public abstract sendMessage(message: ChatP): void;

    // ### Adapter/Chat income/ingress events ###

    public onFriendsListChanged(users: ChatP[]): void
    {
        this.friendsListChangedHandler(users);
    }

    public onMessageReceived(user: ChatP, message: ChatP): void
    {
        this.messageReceivedHandler(user, message);
    }

    // Event handlers
    friendsListChangedHandler: (users: ChatP[]) => void  = (users: ChatP[]) => {};
    messageReceivedHandler: (user: ChatP, message: ChatP) => void = (user: ChatP, message: ChatP) => {};
}